// Category display metadata for the diagnostic workup.
// Icons are Lucide component names (imported by consumers).

export const CATEGORIES = ["blood", "urine", "stool", "genetic", "hormonal", "imaging", "specialty"];

export const CATEGORY_META = {
  blood:     { label: "Blood",     icon: "Droplet",    chip: "bg-red-50 text-red-700 border-red-100",           group: "labs" },
  urine:     { label: "Urine",     icon: "Beaker",     chip: "bg-yellow-50 text-yellow-800 border-yellow-100",  group: "labs" },
  stool:     { label: "Stool",     icon: "TestTube",   chip: "bg-orange-50 text-orange-700 border-orange-100",  group: "labs" },
  genetic:   { label: "Genetic",   icon: "Dna",        chip: "bg-purple-50 text-purple-700 border-purple-100",  group: "labs" },
  hormonal:  { label: "Hormonal",  icon: "HeartPulse", chip: "bg-pink-50 text-pink-700 border-pink-100",        group: "labs" },
  imaging:   { label: "Imaging",   icon: "ScanLine",   chip: "bg-amber-50 text-amber-800 border-amber-200",     group: "imaging" },
  specialty: { label: "Specialty", icon: "Activity",   chip: "bg-emerald-50 text-emerald-700 border-emerald-100", group: "specialty" },
};

export const FILTER_TABS = [
  { key: "all",       label: "All",       groups: ["labs", "imaging", "specialty"] },
  { key: "labs",      label: "Labs",      groups: ["labs"] },
  { key: "imaging",   label: "Imaging",   groups: ["imaging"] },
  { key: "specialty", label: "Specialty", groups: ["specialty"] },
];

export function groupOf(category) {
  return CATEGORY_META[category]?.group || "specialty";
}

export function groupTestsByCategory(tests) {
  const map = {};
  for (const cat of CATEGORIES) map[cat] = [];
  for (const t of tests || []) {
    if (map[t.category]) map[t.category].push(t);
  }
  return CATEGORIES
    .filter((c) => map[c].length > 0)
    .map((c) => ({ category: c, ...CATEGORY_META[c], tests: map[c] }));
}
